// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Header$PdgLookup = require("../components/general/Header.bs.js");
var Search$PdgLookup = require("../components/Particle/Search.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var InfoTable$PdgLookup = require("../components/Particle/InfoTable.bs.js");
var LatexName$PdgLookup = require("../components/Particle/LatexName.bs.js");
var ParticleDataInterface$PdgLookup = require("../data/ParticleDataInterface.bs.js");

var topLevelBlock = Css.style({
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent("center"),
        tl: {
          hd: Css.flexDirection("column"),
          tl: {
            hd: Css.paddingTop({
                  NAME: "percent",
                  VAL: 20
                }),
            tl: {
              hd: Css.marginLeft({
                    NAME: "percent",
                    VAL: 15
                  }),
              tl: {
                hd: Css.marginRight({
                      NAME: "percent",
                      VAL: 15
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var resultBlock = Css.style({
      hd: Css.overflow("hidden"),
      tl: {
        hd: Css.display("flex"),
        tl: {
          hd: Css.flexWrap("wrap"),
          tl: {
            hd: Css.justifyContent("center"),
            tl: /* [] */0
          }
        }
      }
    });

var nameBlock = Css.style({
      hd: Css.display("flex"),
      tl: {
        hd: Css.alignItems("center"),
        tl: {
          hd: Css.$$float("left"),
          tl: {
            hd: Css.paddingRight({
                  NAME: "px",
                  VAL: 15
                }),
            tl: {
              hd: Css.paddingTop({
                    NAME: "px",
                    VAL: 5
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  topLevelBlock: topLevelBlock,
  resultBlock: resultBlock,
  nameBlock: nameBlock
};

function lookupParticle(param, search) {
  var pdg = Belt_Int.fromString(search);
  if (pdg !== undefined) {
    return {
            search: search,
            result: ParticleDataInterface$PdgLookup.getWithPDG(pdg)
          };
  } else {
    return {
            search: search,
            result: ParticleDataInterface$PdgLookup.getWithName(search)
          };
  }
}

function PageParticle(props) {
  var match = React.useReducer((function (s, a) {
          return lookupParticle(s, a);
        }), {
        search: "",
        result: undefined
      });
  var state = match[0];
  var invalidSearch = Belt_Option.isNone(state.result) && state.search.length !== 0;
  var particle = state.result;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Header$PdgLookup.make, {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Search$PdgLookup.make, {
                                    dispatch: match[1],
                                    invalidSearch: invalidSearch
                                  })
                            }),
                        particle !== undefined ? JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(LatexName$PdgLookup.make, {
                                              particle: particle
                                            }),
                                        className: nameBlock
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(InfoTable$PdgLookup.make, {
                                              particle: particle
                                            })
                                      })
                                ],
                                className: resultBlock
                              }) : null
                      ],
                      className: topLevelBlock
                    })
              ]
            });
}

var make = PageParticle;

exports.Styles = Styles;
exports.lookupParticle = lookupParticle;
exports.make = make;
/* topLevelBlock Not a pure module */
